import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';
import * as FormSections from 'depreciations/components/form/sections';

import { createRoute } from 'lib/util';

const DepreciationsForm = ({
  company,
  errors,
  handleAddYear,
  handleRemoveYear,
  handleSubmit,
  handleValueChange,
  isSaving,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSubmitted,
  subcompany,
  t,
  values,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <FormSections.General
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
      />
      <FormSections.Years
        errors={errors}
        values={values}
        handleValueChange={handleValueChange}
        handleAddYear={handleAddYear}
        handleRemoveYear={handleRemoveYear}
        isSubmitted={isSubmitted}
      />
      {/* Groups */}
      <Form.CustomFields
        errors={errors}
        handleCustomFieldChange={handleCustomFieldChange}
        handleGroupChange={handleGroupChange}
        isSubmitted={isSubmitted}
        t={t}
        values={values}
        groups={groups}
      ></Form.CustomFields>
      {/* Groups */}

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `depreciations`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    maximumAmount: {
      type: 'number',
    },
    maximumPercent: {
      type: 'number',
    },
    criteria: {
      type: 'string',
    },
    rates: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          date: {
            type: 'string',
            minLength: 1,
          },
          percentages: {
            type: 'array',
            items: {
              type: 'number',
            },
          },
        },
        required: ['date', 'percentages'],
      },
    },
  },
  required: ['key', 'name', 'criteria', 'rates'],
})(translate()(DepreciationsForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/form/DepreciationForm.js